module.exports = __webpack_public_path__ + "static/img/Image_006.f4e5937.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/Image_006.png
// module id = 9l0w
// module chunks = 3